import i18next from 'i18next';

i18next.addResources('es_CL', 'AddCardSuccess', {
  title: 'Tarjeta agregada exitosamente',
  message:
    'Excelente, acabas de registrar tu tarjeta exitosamente, si estabas realizando una compra dirígete al carrito nuevamente.'
});
